import { render, staticRenderFns } from "./ViewSchool.vue?vue&type=template&id=5739a1c4&scoped=true"
import script from "./ViewSchool.vue?vue&type=script&lang=js"
export * from "./ViewSchool.vue?vue&type=script&lang=js"
import style0 from "./ViewSchool.vue?vue&type=style&index=0&id=5739a1c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5739a1c4",
  null
  
)

export default component.exports